module.exports = __webpack_public_path__ + "img/trash-alt-regular.740028d4.svg";